module.exports = __webpack_public_path__ + "img/xlsx.856cead2.png";